<template>
  <v-container fluid>
    <!-- ENCABEZADO -->
    <v-row class="align-center mb-4">
      <v-col cols="12" md="6" class="d-flex align-center">
        <v-btn icon @click="$router.push({ name: 'SucursalEgresosGastos' })">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="text-h6 font-weight-bold ml-2">Nuevo Gasto</span>
      </v-col>
    </v-row>

    <!-- FORMULARIO PRINCIPAL -->
    <v-row>
      <v-col cols="12" md="8">
        <GastosForm :egreso="egreso" @process:register="onProcessRegister"></GastosForm>
       
        <!-- Botón agregar detalle -->
        <v-btn
          class="mt-4"
          color="primary"
          @click="dialogDetalle = true"
          v-if="false && egreso.tipoIngresoEgreso"
        >
          <v-icon left>mdi-plus</v-icon> Agregar detalle
        </v-btn>

        <!-- Detalles listados -->
        <v-list two-line class="mt-2">
          <v-list-item v-for="(detalle, index) in egreso.detalles" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ detalle.descripcion }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ Number(detalle.monto) | convertPesoArg }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="modificarDetalle(detalle)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="quitarDetalle(detalle)">
                <v-icon small color="red">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <!-- Dialog Detalle -->
        <v-dialog width="600" v-model="dialogDetalle">
          <ValidationObserver ref="formDetalle">
            <v-card>
              <v-card-title>
                Nuevo detalle
                <v-spacer></v-spacer>
                <v-icon @click="dialogDetalle = false">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <VTextAreaWithValidation
                  outlined
                  label="Descripción"
                  autofocus
                  v-model="detalle.descripcion"
                  rules="required|max:100"
                  :counter="100"
                  name="descripción"
                  rows="2"
                />
                <VTextFieldWithValidation
                  outlined
                  label="Monto"
                  v-model="detalle.monto"
                  rules="required|decimal|max:30"
                  name="monto"
                />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogDetalle = false">Cancelar</v-btn>
                <v-btn color="success" @click="añadirDetalle;">Agregar</v-btn>
              </v-card-actions>
            </v-card>
          </ValidationObserver>
        </v-dialog>
      </v-col>

      <!-- Vista Previa -->
      <v-col v-if="false" cols="12" md="4">
        <v-card>
          <v-card-title>Vista previa</v-card-title>
          <v-card-text>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-calendar</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ formatFechaPeriodo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <div v-if="egreso.categoria">
              <v-list-item>
                <v-list-item-avatar>
                  <v-chip :color="egreso.categoria.color"></v-chip>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    egreso.categoria.name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>

            <div v-if="egreso.descripcion">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-comment</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    egreso.descripcion
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>

            <v-divider class="my-2"></v-divider>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-h4">
                  {{ egreso.monto | convertPesoArg }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  Subtotal Detalles: {{ subtotal() | convertPesoArg }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- BOTÓN REGISTRAR FIJO -->
    <v-footer app padless>
      <v-col class="pa-4"> </v-col>
    </v-footer>

    <!-- Diálogo Confirmación -->
    <dialog-confirmation-close
      v-if="dialogRegistrarGasto"
      :buttonCancel="false"
      @close-dialog="dialogRegistrarGasto = false"
      @process-button-extra="registrarEgreso(false)"
      @process-accept="registrarEgreso(true)"
    >
      <template v-slot:titulo>¿Vas a pagar con dinero de la caja?</template>
      <template v-slot:message>
        <p>Si utilizas dinero de la caja, seleccioná <b>Pagar con caja</b></p>
        <p>En caso contrario, selecciona <b>Pagar de otra manera</b></p>
      </template>
      <template v-slot:buttonExtra>Pagar de otra manera</template>
      <template v-slot:buttonOK>Pagar con caja</template>
    </dialog-confirmation-close>
  </v-container>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import GastosForm from "@/views/pos/egresos/components/GastosForm.vue";
import VTextFieldWithValidation from "@/components/inputs/VTextFieldWithValidation";
import VTextAreaWithValidation from "@/components/inputs/VTextAreaWithValidation";
import DialogConfirmationClose from "@/components/dialogs/confirmation.close";
import moment from "moment";

export default {
  name: "GastosSucursalRegistrar",
  components: {
    ValidationObserver,
    GastosForm,
    VTextFieldWithValidation,
    VTextAreaWithValidation,
    DialogConfirmationClose,
  },
  filters: {
    convertPesoArg(value) {
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
  data() {
    return {
      dialogDetalle: false,
      dialogRegistrarGasto: false,
      egreso: {
        tipoIngresoEgreso: null,
        descripcion: "",
        categoria: null,
        monto: 0,
        detalles: [],
        esIngreso: false,
        fechaPeriodo: new Date().toISOString().substr(0, 7),
        formaDePago: null,
      },
      detalle: { descripcion: "", monto: null },
    };
  },
  computed: {
    validRegister() {
      return (
        this.egreso.tipoIngresoEgreso &&
        this.egreso.categoria &&
        (this.egreso.monto > 0 || this.egreso.detalles.length > 0)
      );
    },
    formatFechaPeriodo() {
      return moment(this.egreso.fechaPeriodo).format("MMMM-YYYY").toUpperCase();
    },
  },
  methods: {
    subtotal() {
      return this.egreso.detalles.reduce(
        (total, item) => total + parseFloat(item.monto || 0),
        0
      );
    },
    async añadirDetalle() {
      const result = await this.$refs.formDetalle.validate();
      if (result) {
        this.egreso.detalles.push({ ...this.detalle });
        this.detalle = { descripcion: "", monto: null };
        this.dialogDetalle = false;
      }
    },
    quitarDetalle(detalle) {
      const index = this.egreso.detalles.indexOf(detalle);
      if (index >= 0) {
        this.egreso.detalles.splice(index, 1);
      }
    },
    modificarDetalle(detalle) {
      this.detalle = { ...detalle };
      this.quitarDetalle(detalle);
      this.dialogDetalle = true;
    },
    onProcessRegister() {
      // Pagar "con caja" (dinero físico del cajón) solo tiene sentido si la
      // forma de pago es EFECTIVO. Con transferencia/tarjeta/etc no aplica:
      // se registra directo, sin tocar ningún arqueo.
      const formaDePago = this.egreso.formaDePago;
      const esEfectivoOSinElegir = !formaDePago || formaDePago.nombre === "EFECTIVO";
      if (esEfectivoOSinElegir) {
        this.dialogRegistrarGasto = true;
      } else {
        this.registrarEgreso(false);
      }
    },
    async registrarEgreso(pagarConCaja = false) {
      try {
        if (this.egreso.detalles.length > 0) {
          this.egreso.monto = this.subtotal();
        }
        this.egreso.pagaConCaja = pagarConCaja;
        if (pagarConCaja) {
          this.egreso.formaDePago = null;
        }

        await this.axios.post("/egresos/ingresoegreso", this.egreso);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "success",
          text: "Egreso registrado correctamente",
          icon: "mdi-check",
          timeout: 3000,
        });

        this.$router.push({ name: "SucursalEgresosGastosCategoria" });
      } catch (error) {
        this.dialogRegistrarGasto = false;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: error.response?.data?.data || "Error al registrar",
          icon: "mdi-alert",
        });
      }
    },
  },
};
</script>


